var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgProvidedInStoreMobileLogo = function SvgProvidedInStoreMobileLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#providedInStoreMobileLogo_svg__clip0_14088_42866)",
    fill: "#767676"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.083 7.412H2.917v.583h8.166v-.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.417 5.079A.584.584 0 0014 4.495V3.33a.584.584 0 00-.583-.584H12.6L11.813.78a.584.584 0 00-.541-.367H2.728a.583.583 0 00-.541.367L1.4 2.745H.583A.584.584 0 000 3.33v1.166c0 .322.262.584.583.584h.584v8.75H0v.583h14v-.583h-1.167v-8.75h.584zM2.728.995h8.544l.7 1.75H2.028l.7-1.75zm-2.145 3.5V3.33h12.834v1.166H.583zM3.5 13.83V9.745h2.333v4.084H3.5zm4.667 0V9.745H10.5v4.084H8.167zm4.083 0h-1.167V9.745a.584.584 0 00-.583-.583H8.167a.584.584 0 00-.584.583v4.084H6.417V9.745a.584.584 0 00-.584-.583H3.5a.584.584 0 00-.583.583v4.084H1.75v-8.75h10.5v8.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "providedInStoreMobileLogo_svg__clip0_14088_42866"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .412)",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgProvidedInStoreMobileLogo;